// Pages/NotFound.jsx
const NotFound = () => {
  return (
    <div
      className="prefer-light brightness"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        "--br-value": "1.28",
      }}
    >
      <h1
        className="text-clip"
        style={{
          margin: "auto",
          "--clip-color": "#212529",
          "--drop-shadow": "#FFA83E",
        }}
      >
        404 – Page Not Found
      </h1>
    </div>
  );
};

export default NotFound;
